module.exports = __webpack_public_path__ + "static/img/5.d0ccc66.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/zh/5.png
// module id = XAuB
// module chunks = 0